import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { Injectable } from '@angular/core';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { AppTextService } from '@fi-shared/app-text';
import { FiLogErrorService } from '@fi-shared/fi-shared-services/fi-log-error.service';
import { FiGiphySize } from '@fi-shared/fi-giphy/fi-giphy-size';
import { IGiphyItem } from '@fi-shared/fi-giphy/fi-giphy';

const apiKey = '1tsPfDHjwF0OHdxeHF86YBtKqC01oMd3'; //todo move to environment

interface IFiGiphySearchResponseData {
    id: string;
    title: string;
    images: {
        [prop: string]: {
            height: string;
            width: string;
            size: string;
            url: string;
        };
    };
}

interface IFiGiphySearchResponse {
    data: IFiGiphySearchResponseData[];
}

@Injectable()
export class FiGiphyService {
    constructor(
        private fiBackend: FiBackendService,
        private fiDialogsService: FiDialogsService,
        private appTextService: AppTextService,
        private logErrorService: FiLogErrorService,
    ) {}
    private readonly offsetStep = 15;
    private trendingOffset: number = 0;
    private searchOffset: number = 0;

    search(searchStr: string, giphySize: FiGiphySize, limit = 15): Promise<IGiphyItem[]> {
        const url = `https://api.giphy.com/v1/gifs/search?api_key=${apiKey}&q=${searchStr}&limit=${limit}&offset=${this.searchOffset}`; // &rating=g&lang=en
        this.searchOffset += this.offsetStep;
        return new Promise<IGiphyItem[]>((resolve, reject) => {
            this.searchInternal(url).then((result) => {
                resolve(this.getGifsData(giphySize, result));
            }, reject);
        });
    }

    getTrendingGifs(giphySize: FiGiphySize, limit: number = 15): Promise<IGiphyItem[]> {
        const url = `https://api.giphy.com/v1/gifs/trending?api_key=${apiKey}&limit=${limit}&offset=${this.trendingOffset}`;
        this.trendingOffset += this.offsetStep;
        return new Promise<IGiphyItem[]>((resolve, reject) => {
            this.searchInternal(url).then((result) => {
                resolve(this.getGifsData(giphySize, result));
            }, reject);
        });
    }

    resetTrendingOffset() {
        this.trendingOffset = 0;
    }

    resetSearchOffset() {
        this.searchOffset = 0;
    }

    private getGifsData(giphySize: FiGiphySize, result: IFiGiphySearchResponse): IGiphyItem[] {
        const size = FiGiphySize[giphySize];
        const originalSize = FiGiphySize[FiGiphySize.original];
        return result.data.map((item) => {
            const imageData = item.images[size];
            const originalImageData = item.images[originalSize];
            return {
                id: item.id,
                title: item.title,
                height: imageData.height,
                width: imageData.width,
                size: imageData.size,
                url: imageData.url,
                originalUrl: originalImageData.url,
            };
        });
    }

    private searchInternal(url: string): Promise<IFiGiphySearchResponse> {
        const promise = this.fiBackend.fetchData<IFiGiphySearchResponse>(url, {
            absolutePath: true,
        });
        promise.catch((err) => {
            this.logErrorService.logError('giphy ' + JSON.stringify(err.error || err));
        });
        return promise;
    }
}
